import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { RestApi } from 'app/auth/rest.api';
import { IDataCharts } from '../common/models/IDataCharts';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';
import { IQueueItem } from '../common/models/IQueueItem';
import { IUipathJob } from '../common/models/IUipathJob';


@Injectable({
  providedIn: 'root'
})
export class RestApiUipathService {

  private _rpaBots = 'api/bots';
  constructor(
    private _restApi: RestApi
  ) { }

  public getJobs(connectionType: string, filter: string, tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<IODataResponse<IUipathJob[]>> {
    return this._restApi.post(`${this._rpaBots}/jobs`, {
      connectionType: connectionType,
      token: tokenAut,
      filter: filter,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
     });
  }

  public getJobsCC(connectionType: string, filter: string, tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string,
    organizationUnits: string[]
    ): Observable<IODataResponse<IUipathJob[]>> {
    return this._restApi.post(`${this._rpaBots}/jobsCC`, {
      connectionType: connectionType,
      token: tokenAut,
      filter: filter,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId,
      organizationUnits : organizationUnits
    });
  }

  public getQueueItems(connectionType: string, filter: string,
    tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string,
    tenantLogicalName: string,
    clientId: string): Observable<IODataResponse<Array<IQueueItem>>> {
    return this._restApi.post(`${this._rpaBots}/queueitems`, {
      connectionType: connectionType,
      token: tokenAut,
      filter: filter,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
    });
  }

  public getQueueItemsCC(connectionType: string, filter: string,
    tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string,
    tenantLogicalName: string,
    clientId: string, organizationUnits: string[]): Observable<IODataResponse<Array<IQueueItem>>> {
    return this._restApi.post(`${this._rpaBots}/queueitemsCC`, {
      connectionType: connectionType,
      token: tokenAut,
      filter: filter,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId,
      organizationUnits: organizationUnits
    });
  }

  public getToken(rpaConnectionUiPath : IRpaConnectionUiPath
    ): Observable<string> {
    return this._restApi.post(`${this._rpaBots}/authenticate`, rpaConnectionUiPath
    );
  }

  public startJob(connectionType: string, tokenAut: string, releaseKey: string, inputArguments: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<Array<any>> {
    let post = this._restApi.post(`${this._rpaBots}/startjob`, {
      connectionType: connectionType,
      token: tokenAut,
      releaseKey: releaseKey,
      inputArguments: inputArguments,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
     });
    return post;
  }

  public addQueueItem(connectionType: string, tokenAut: string, queueName: string, priority: string, specificContent: string, deferDate: string, dueDate: string, reference: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<any> {
    return this._restApi.post(`${this._rpaBots}/queueitem`, {
      connectionType: connectionType,
      token: tokenAut,
      queueName: queueName,
      priority: priority,
      specificContent: specificContent,
      deferDate: deferDate,
      dueDate: dueDate,
      reference: reference,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
    });
  }


  public retryQueueItem(connectionType: string, tokenAut: string, queueitemId: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<any> {
    return this._restApi.post(`${this._rpaBots}/queueitemretry`, {
      connectionType: connectionType,
      token: tokenAut,
      queueitemId: queueitemId,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
    });
  }

  public GetQueueNameByDefinitionId(connectionType: string, tokenAut: string, queueDefinitionId: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<string> {
    return this._restApi.post(`${this._rpaBots}/queuename`, {
      connectionType: connectionType,
      token: tokenAut,
      queueDefinitionId: queueDefinitionId,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
    });
  }

  public getReleaseKey(connectionType: string, tokenAut: string, processKey: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<string> {
    return this._restApi.post(`${this._rpaBots}/releasekey`, {
      connectionType: connectionType,
      token: tokenAut,
      processKey: processKey,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
    });
  }

  public getJobsDataCharts(connectionType: string, tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<IDataCharts> {
    return this._restApi.post(`${this._rpaBots}/chartsjobsdata`, {
      connectionType: connectionType,
      token: tokenAut,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
    });
  }

  public getQueueitemsDataCharts(connectionType: string, tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string): Observable<IDataCharts> {
    return this._restApi.post(`${this._rpaBots}/chartsqueueitemsdata`, {
      connectionType: connectionType,
      token: tokenAut,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId
    });
  }

  public getJobsDataChartsCC(connectionType: string, tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string, organizationUnits: string[]): Observable<IDataCharts> {
    return this._restApi.post(`${this._rpaBots}/jobstatscc`, {
      connectionType: connectionType,
      token: tokenAut,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId,
      organizationUnits: organizationUnits
    });
  }

  public getQueueitemsDataChartsCC(connectionType: string, tokenAut: string, urlServer: string,
    userKey: string, accountLogicalName: string, tenantLogicalName: string, clientId: string, organizationUnits: string[]): Observable<IDataCharts> {
    return this._restApi.post(`${this._rpaBots}/queitemstatscc`, {
      connectionType: connectionType,
      token: tokenAut,
      urlServer: urlServer,
      userKey: userKey,
      accountLogicalName: accountLogicalName,
      tenantLogicalName: tenantLogicalName,
      clientId: clientId,
      organizationUnits: organizationUnits
    });
  }

}

